// VzmRadioForBool.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024.
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppStyle } from "../value/AppConst";

const TitleLabel = styled('div')({fontSize: '0.8rem', color:AppStyle.PrimaryRGB});

export default function VzmRadioForBool({
    dict,
    value,
    onChange,
    onFocused,
    onMouseEnter,
    disabled,
}) {
    const TrueValue = dict.trueValue || true;
    const FalseValue = dict.falseValue || false;

    const onChangeValue = (e) => {
        const value = e.target.value; // ? TrueValue : FalseValue; // ? true : false;
        onChange(dict.id, value);
    };

    const inRow = dict.column ? false : true; // whether in row or column

    return(
        <>
        {
            dict.label ?
            <TitleLabel>{dict.label}</TitleLabel>
            : null
        }
        <RadioGroup aria-label={dict.id} name={dict.id} value={value || ''}
            onChange={onChangeValue}
            onMouseEnter={()=>{if(onMouseEnter) onMouseEnter(dict)}}
            onFocus={()=>{if(onFocused) onFocused(dict)}}
            row={inRow}
        >
            <FormControlLabel
                value={TrueValue} control={<Radio disabled={disabled} />}
                label={dict.select.true}
            />
            <FormControlLabel
                value={FalseValue} control={<Radio disabled={disabled}/>}
                label={dict.select.false}
            />
        </RadioGroup>
        </>
    );
}